
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="vp-sub-folder-menu-dialog mail-dialog">
    <div class="mail__dialog-body mail__dialog-body--pad disable-select" (scroll)="onUserScroll($event)">
        <ng-container *ngIf="!isMenuClicked">
            <div id="mobile_sidebar_folder_folderlist-1" class="sidebar-list disable-select" *ngIf="selectedMailFolder && selectedMailFolder?.children">
                <mat-list>
                    <mat-list-item (click)="getParentFolder()">
                        <div class="folder-icon disable-select">
                            <mat-icon class="disable-select">subdirectory_arrow_left</mat-icon>
                        </div>
                        <div class="folder-title disable-select">
                            <span class="disable-select">...</span>
                        </div>
                    </mat-list-item>
                </mat-list>
                <cdk-virtual-scroll-viewport class="sub-folders-list sub-folders-inner-block" itemSize="30" style="height: calc(80vh - 80px);">
                    <mat-list>
                        <ng-container *cdkVirtualFor="let folder of selectedMailFolder.children">
                            <mat-list-item vpLongPress [timeout]="500"
                                (onLongPress)="$event.stopPropagation(); openActionList(folder)"
                                (click)="routeToFolder(folder)">
                                <div class="folder-icon disable-select">
                                  <ng-container *ngTemplateOutlet="folderIcon; context: { color: folder.rgb || '#808080' }"></ng-container>
                                </div>
                                <div class="folder-title disable-select">
                                    <span class="disable-select"
                                        [ngClass]="{'broken-share-folder': folder.owner && !folder.oname}">
                                        {{ mailService?.getFolderNameKey(folder.name, MailConstants?.SYSTEM_FOLDERS) }}
                                    </span>
                                </div>
                                <div class="folder-expander disable-select" *ngIf="folder.children"
                                    (click)="$event.preventDefault(); $event.stopPropagation(); getChildrens(folder)">
                                    <mat-icon id="mobile_sidebar_folder_expand"
                                        class="disable-select">keyboard_arrow_right</mat-icon>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </cdk-virtual-scroll-viewport>
            </div>

            <div *ngIf="selectedMailFolder && !selectedMailFolder.children">
                <mat-list>
                    <mat-list-item (click)="getParentFolder()">
                        <div class="folder-icon disable-select">
                            <mat-icon class="disable-select">subdirectory_arrow_left</mat-icon>
                        </div>
                        <div class="folder-title disable-select">
                            <span class="disable-select">...</span>
                        </div>
                    </mat-list-item>
                </mat-list>
                <div class="no-folder-division">
                    {{ 'EMPTY_SUB_FOLDER_CREATE_MSG' | translate }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isMenuClicked">
            <div class="sidebar-list disable-select user-folders">
                <mat-list>
                    <ng-container *ngIf="systemFolders">
                        <ng-container
                            *ngTemplateOutlet="recursiveSystemFolder; context: { folders: systemFolders }"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="rootUserFolders">
                        <ng-container
                            *ngTemplateOutlet="recursiveFolder; context: { folders: rootUserFolders | vpFolderNameSearch : searchText }"></ng-container>
                    </ng-container>
                </mat-list>
            </div>
        </ng-container>
    </div>
    <ng-template #recursiveFolder let-folders="folders">
        <ng-container *ngFor="let folder of folders">
            <mat-list-item vpLongPress [timeout]="500" (onLongPress)="$event.stopPropagation(); openActionList(folder)"
                (click)="routeToFolder(folder)">
                <div class="folder-row">
                    <div class="folder-icon">
                        <div class="folder-expander" *ngIf="folder.children?.length"
                            (click)="$event.preventDefault(); $event.stopPropagation(); toggleExpand(folder, $event)">
                            <mat-icon>{{ isExpanded(folder) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                        </div>
                        <div style="margin-left: 10px !important;">
                          <ng-container *ngTemplateOutlet="folderIcon; context: { color: folder.rgb || '#808080' }"></ng-container>
                        </div>
                        <span class="mail-count"
                            *ngIf="folder.name !== 'Drafts' && folder.u && folder.u !== '0' && folder.u !== 0">
                            {{ folder.u > 99 ? '99+' : folder.u }}
                        </span>
                    </div>
                    <div class="folder-title" [ngClass]="{ 'broken-share-folder': folder.owner && !folder.oname }">
                        {{ mailService?.getFolderNameKey(folder.name, MailConstants?.SYSTEM_FOLDERS) }}
                    </div>
                </div>
            </mat-list-item>
            <div *ngIf="folder.children?.length && isExpanded(folder)" class="subfolder-list">
                <mat-list>
                    <ng-container
                        *ngTemplateOutlet="recursiveFolder; context: { folders: folder.children }"></ng-container>
                </mat-list>
            </div>
        </ng-container>
    </ng-template>
    <ng-template #recursiveSystemFolder let-folders="folders">
        <ng-container *ngFor="let folder of folders">
            <mat-list-item vpLongPress [timeout]="500" (onLongPress)="$event.stopPropagation(); openActionList(folder)">
                <div class="folder-row">
                    <div class="folder-icon">
                        <div class="folder-expander" *ngIf="folder.children?.length"
                            (click)="$event.preventDefault(); $event.stopPropagation(); toggleExpand(folder, $event)">
                            <mat-icon>{{ isExpanded(folder) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                        </div>
                        <mat-icon *ngIf="folder.icon" [style.color]="folder.rgb || '#808080'"
                            style="margin-left: 10px !important;">
                            {{ folder.icon }}
                        </mat-icon>
                        <div *ngIf="!folder.icon" style="margin-left: 10px !important;">
                          <ng-container *ngTemplateOutlet="folderIcon; context: { color: folder.rgb || '#808080' }"></ng-container>
                        </div>

                        <span class="mail-count"
                            *ngIf="folder.name !== 'Drafts' && folder.u && folder.u !== '0' && folder.u !== 0">
                            {{ folder.u > 99 ? '99+' : folder.u }}
                        </span>
                    </div>
                    <div class="folder-title" [ngClass]="{ 'broken-share-folder': folder.owner && !folder.oname }"
                        (click)="routeToFolder(folder, true)">
                        {{ (folder?.name | lowercase) === 'starred' ? ('FAVOURITES' | translate) :
                        mailService?.getFolderNameKey(folder.name, MailConstants?.SYSTEM_FOLDERS) }}
                    </div>
                </div>
            </mat-list-item>
            <div *ngIf="folder.children?.length && isExpanded(folder)" class="subfolder-list">
                <mat-list>
                    <ng-container
                        *ngTemplateOutlet="recursiveSystemFolder; context: { folders: folder.children }"></ng-container>
                </mat-list>
            </div>
        </ng-container>
    </ng-template>

    <vp-mail-operation-button (click)="createNewFolder(selectedMailFolder)"[iconType]="globalOperationIcon">

    </vp-mail-operation-button>
</div>
<ng-template #folderIcon let-color="color">
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/folder-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(2.000000, 4.000000)" [style.fill]="color">
              <path d="M7.00922203,0 C7.49995184,0 8.18025928,0.262988878 8.59481703,0.605726148 L8.71075654,0.71075654 L9.28924346,1.28924346 C9.65129486,1.65129486 10.3113868,1.94247309 10.8421188,1.99242242 L10.9970301,2 L18,2 C19.05,2 19.9177686,2.82004132 19.9944872,3.85130541 L20,4 L20,14 C20,15.05 19.1799587,15.9177686 18.1486946,15.9944872 L18,16 L2,16 C0.95,16 0.082231405,15.1799587 0.00551277235,14.1486946 L0,14 L0.01,2 C0.01,0.95 0.820929752,0.082231405 1.85136551,0.00551277235 L2,0 L7.00922203,0 Z M7.00922203,2 L2.00999931,2.00166667 L2,14 L18,14 L18,4 L10.9970301,4 C9.98506984,4 8.81419501,3.54226902 8.03565409,2.85431634 L7.8750299,2.70345702 L7.29654298,2.1249701 L7.27022108,2.10994272 L7.0847011,2.02870664 L7.00922203,2 Z" id="Shape"
              [style.fill]="color"></path>
          </g>
      </g>
  </svg>
</ng-template>